
export default class ReportingSearchDto {
  marcheId;
  ligneId;
  statut;
  date;
  trimestreId;
  onglets = [];
  types;
}